"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _Footer = require("./Footer.styles");
var _Button = require("../../../Button");
var _hooks = require("../../../../hooks");
var _Select = require("../../Select.labels");
var _jsxRuntime = require("react/jsx-runtime");
const Footer = props => {
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    isOptionsSelected,
    onClearSelectedOptions,
    onSaveSelectedOptions
  } = props;
  const styles = (0, _Footer.useStyles)(props);
  const getLabel = (0, _hooks.useLabels)({
    labels: _Select.labels
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Select__footer'],
    children: [!isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: isOptionsSelected && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        id: "ccSelectFooterClear",
        view: "link",
        color: "primary",
        size: "small",
        onClick: onClearSelectedOptions,
        children: getLabel('clear')
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      isDisabled: !isOptionsSelected,
      id: "ccSelectFooterSave",
      view: "contained",
      color: "primary",
      size: isMobileView ? 'stretch' : 'small',
      shape: isMobileView ? 'rectangle' : 'ellipse',
      onClick: onSaveSelectedOptions,
      children: getLabel('confirm')
    })]
  });
};
exports.Footer = Footer;